export const isLockerPurchaseLocked = (lockedUntil?: string | null): boolean => {
  if (!lockedUntil) return false;
  return new Date(lockedUntil).getTime() > Date.now();
};

